import React from 'react';
import cls from './Gant.module.css';
import classNames from 'classnames';
import { Header } from './Header/Header';
import { useGant } from './useGant';
import { Body } from './Body/Body';

export const Gant = ({ stages }) => {
    useGant();
    return (
        <div className={classNames(cls.wrapper)}>
            <Header />
            <Body stages={stages} />
        </div>
    );
};
